<template>
  <div class="mask" v-show="value">
    <div class="captcha-content">
      <p class="captcha-title">
        <span @click="back"></span>
        {{title}}
      </p>
      <div class="captcha-input-wrap">
        <input
          type="text"
          readonly="readonly"
          name="captchaInput"
          placeholder="请输入验证码"
          v-model="code"
          minlength="6"
          :maxlength="maxlength"
          class="captcha-input"
          id="captchaInput"
        >
        <label class="captcha-getBtn" @click="$_onResend">{{countBtnText}}</label>
      </div>
      <p class="captcha-hassend" v-show="hasSend">已向您尾号{{phone|last}}的手机号发送验证码</p>
      <button
        class="captcha-comfirmBtn"
        @click="$_onSubmit"
        :class="[hasSend?'actived':'disabled']"
      >确认</button>
      <ul class="kbd">
        <li @click="$_put('1')">1</li>
        <li @click="$_put('2')">2</li>
        <li @click="$_put('3')">3</li>
      </ul>
      <ul class="kbd">
        <li @click="$_put('4')">4</li>
        <li @click="$_put('5')">5</li>
        <li @click="$_put('6')">6</li>
      </ul>
      <ul class="kbd">
        <li @click="$_put('7')">7</li>
        <li @click="$_put('8')">8</li>
        <li @click="$_put('9')">9</li>
      </ul>
      <ul class="kbd">
        <li style="background-color:#D1D5DB;"></li>
        <li @click="$_put('0')">0</li>
        <li @click="$_put('back')" style="background-color:#D1D5DB;" class="back"></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "md-captcha",

  filters: {
    last(val) {
      if (val) {
        return val.slice(-4);
      }
      return "";
    }
  },

  props: {
    title: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [Number, String],
      default: 4
    },
    autoCountdown: {
      type: Boolean,
      default: false
    },
    appendTo: {
      default: () => document.body
    },
    count: {
      type: Number,
      default: 60
    },
    countNormalText: {
      type: String,
      default: "获取验证码"
    },
    countActiveText: {
      type: String,
      default: "重新发送({$1})"
    },
    phone: {
      type: String
    },
    hasSend: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      code: "|",
      visible: false,
      errorMsg: "",
      isCounting: false,
      firstShown: false,
      countBtnText: this.countNormalText,
      clearIntervalId: undefined
    };
  },
  watch: {
    value(val) {
      if (!val) {
        this.code = "";
      }
    }
  },

  mounted() {
    if (this.appendTo) {
      this.appendTo.appendChild(this.$el);
    }

    this.animateCode()
  },

  beforeDestroy() {
    if (this.appendTo) {
      this.appendTo.removeChild(this.$el);
    }

    clearInterval(this.clearIntervalId)
  },

  methods: {
    animateCode() {
      let isFlag = false
      this.clearIntervalId = setInterval(() => {
        if(isFlag) {
          this.code = this.code === '|' ? ' ' : this.code.replace('|', '')
          isFlag = false
        } else {
          this.code = this.code.replace('|', '') + '|'
          isFlag = true
        }
      }, 1000)
    },
    _filterCode(value, newVal) {
      let filterValue = value.replace('|', '')
      if(newVal === '') {
        filterValue = filterValue.slice(0, -1) + '|'
      } else {
        filterValue = filterValue + '' + newVal + '|' // (l === 5? '': '|')
      }

      return filterValue
    },
    // MARK: events handler, 如 $_onButtonClick
    $_put(val) {
      if (val == "back") {
        this.code = this._filterCode(this.code, '')
      } else {
        let code = this.code.replace(' ', '')
        code = code.replace('|', '')

        if (code.length < 6) {
          this.code = this._filterCode(this.code, val);
        }
      }
    },
    $_onSubmit() {
      let filterCode = this.code.replace('|', '').trim()
      this.$emit("submit", filterCode);
    },
    $_onResend() {
      if (!this.isCounting) {
        this.countdown();
        this.$emit("send", this.countdown);
      }
    },
    back() {
      this.$emit("input", false);
    },
    // MARK: public methods
    countdown() {
      if (!this.count) {
        return;
      }
      clearInterval(this.__counter__);
      let i = this.count - 1;
      this.isCounting = true;
      this.countBtnText = this.countActiveText.replace("{$1}", i);
      /* istanbul ignore next */
      this.__counter__ = setInterval(() => {
        if (i === 1) {
          this.resetcount();
        } else {
          i--;
          this.countBtnText = this.countActiveText.replace("{$1}", i);
        }
      }, 1000);
    },
    resetcount() {
      this.isCounting = false;
      // this.hasSend=false;
      this.countBtnText = this.countNormalText;
      clearInterval(this.__counter__);
    },
    setError(msg) {
      this.$nextTick(() => {
        this.errorMsg = msg;
        this.code = "";
      });
    }
  }
};
</script>

<style scoped>
.mask {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
}

.captcha-content {
  position: absolute;
  /* top: 30.7%; */
  width: 100%;
  background-color: #fff;
  text-align: center;
  z-index: 2;
  bottom: 0;
  /* bottom: -100%; */
  /* transition: bottom 0.5s ease; */
}

.captcha-title {
  font-size: 0.34rem;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  padding: 0.2rem 0;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #cccccc;
  margin: 0;
  position: relative;
}

.captcha-title > span {
  left: calc(50% - 3.45rem);
  background-size: contain;
  background-repeat: no-repeat;
  width: 0.4rem;
  height: 0.4rem;
  top: 0.29rem;
  position: absolute;
  background-image: url("./back.png");
}

.captcha-getBtn {
  font-size: 0.31rem;
  color: #4F8BE8;
  letter-spacing: 0;
  text-align: right;
}

.captcha-comfirmBtn {
  font-size: 0.36rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  width: 6.9rem;
  height: 0.84rem;
  margin: 0.3rem 0;
}

.captcha-hassend {
  font-size: 0.28rem;
  color: #ff6841;
  letter-spacing: 0;
  text-align: left;
  padding-left: calc(50% - 3.45rem);
  margin-top: 0.1rem;
  margin-bottom: 0;
}

.captcha-input-wrap {
  position: relative;
  margin-top: 0.3rem;
  text-align: center;
}

.captcha-input-wrap > label {
  position: absolute;
  right: calc(50% - 3.35rem + 0.3rem);
  height: 0.8rem;
  /* padding: 0.22rem 0; */
  /* margin-top: 0.22rem; */
  top: 0;
  /* height: 0.75rem; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.captcha-input {
  width: 6.9rem;
  line-height: 0.75rem;
  border: 0.01rem solid #cccccc;
  border-radius: 0.04rem;
  font-size: 0.3rem;
  color: #333;
  letter-spacing: 0;
  text-indent: 1em;
  box-sizing: border-box;
}

.captcha-input::-webkit-input-placeholder {
  color: #999999;
}

.captcha-comfirmBtn.disabled {
  background-color: #d9d9d9;
}

.captcha-comfirmBtn.actived {
  background-color: #3a9bde;
}

.kbd {
    border-top: 0.01rem solid #ccc;
    white-space: nowrap;
    font-size: 0;
    user-select: none;
}

.kbd > li {
  display: inline-block;
  width: 33.33333333%;
  height: 1.086rem;
  border-right: 0.01rem solid #ccc;
  line-height: 1.086rem;
  font-size: 0.56rem;
  color: #030303;
  letter-spacing: 0;
  text-align: center;
  vertical-align: top;
}

.kbd > li:last-child {
  border-right: none;
}

.captcha-input:disabled {
  background-color: #fff;
}
.back{
  background-image: url('./back2.png');
  background-size:0.458rem 0.34rem;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/vxmobile/components/captcha/index.vue